var browserSupport = require('./browserSupport');

// expose for use from outside this scope //
window.MyWebsiteShowroomIntegrator =
    browserSupport.canRunShowroom() ?
    require('./host/integratorApi').integratorApi :
    {
        // If browser is not supported, inline some basic code that's guaranteed
        // to work on any outdated browser
        /** @see IntegratorApi#init */
        init: function(container, baseShowroomUrl, locale, host, config) {
            // set the content of the container to be an iframe //
            while (container.lastChild) {
                container.removeChild(container.lastChild);
            }

            var iframe = document.createElement("iframe");
            iframe.style.padding = 'none';
            iframe.style.border = 'none';
            iframe.style.padding = 'none';
            iframe.style.height = '755px';
            iframe.style.width = '100%';
            container.appendChild(iframe);

            iframe.src = baseShowroomUrl + '?locale=' + locale + '&host=' + host;
        },
        isBrowserSupported: function() {
            return false;
        }
    };


//////////////////
// WEBPACK FOOTER
// ./bootstrapHost.js
// module id = 0
// module chunks = 2